import { Component, OnInit, Injector, Inject, PLATFORM_ID, ViewChild, ElementRef, AfterViewInit } from "@angular/core";
import { HomeComponent } from "../home/home.component";
import { MainUIServiceService } from "../../services/main-uiservice.service";
import { QuotePanelsTabsList, quotePanelsTabsParams } from "../../enums/QuotePanelsTabs.list";
import { AlertState } from "../../enums/alert-state";
import { MobileMainView } from "../../enums/mobile-mainViews";
import {
    quoteFilterTabsParams,
    quoteFilterTabsList,
    quoteFilterTabsParamsMobile,
    quoteFilterTabsParamsOanda
} from "../quoteFilterTabs/quoteFilterTabs.list";
import { MobileAchartComponent } from "../mobile-achart/mobile-achart.component";
import { tradeDeskTabsParams } from "../tradedeskTabs/tradedeskTabs.list";
import { BoxQuotaData } from "../../model/box.quote.data";
import { ChartDisplayMode } from "../../enums/ChartDisplayMode.list";
import { RoutingService } from "../../services/routing.service";
import { ActivatedRoute } from "@angular/router";
import {SymbolTypeEnum} from "../../enums/SymbolType.enum";
import {Providers} from "../../enums/providers";

@Component( {
    selector: "mobile-home",
    template: require('./mobile-home.component.html'),
    styles: [ require('../home/home.component.css'), require('./mobile-home.component.css') ]
} )
export class MobileHomeComponent extends HomeComponent implements OnInit, AfterViewInit {
    @ViewChild( "mobileFooter" )
    mobileFooter?: ElementRef;

    @ViewChild( "header" )
    header?: ElementRef;

    @ViewChild( "landingHeader" )
    landingHeader?: ElementRef;

    @ViewChild( "buttonPans" )
    buttonPans?: ElementRef;

    get filteredBoxes () {
        return this.boxes.filter( b => b.visible && b.searchVisible );
    }

    get hideHeader () {
        return this.currentView == this.mobileMainViewENUM.CHARTING;
    }

    get headerHeightPx () {
        // if(this.hideHeader)
        //   return 0;

        if ( this.header == null || this.header.nativeElement == null ) return 0;

        return this.header.nativeElement.offsetHeight || 0;
    }

    get mainColumnHeight () {
        return "calc(100% - " + this.headerHeightPx + "px)";
    }

    constructor (
        injector: Injector,
        @Inject( PLATFORM_ID ) private _platformId: Object,
        private _mainUIService: MainUIServiceService
    ) {
        super( injector, _platformId, _mainUIService );
    }

    get landingHeaderHeight () {
        if ( this.landingHeader == null || this.landingHeader.nativeElement == null ) return 0;

        return this.landingHeader.nativeElement.offsetHeight || 0;
    }

    get horizontalMode () {
        return this.workspace.horizontalMode;
    }

    get showAds (): boolean {
        return this.dataService.EnableAdSpace
    }

    get panStyle () {
        if ( this.showAds ) {
            return { height: 'calc(100% - 55px)' };
        }
        else {
            return { height: 'calc(100% - 10px)' };
        }
    }


    ngAfterViewInit () {
        setTimeout( () => {
            console.log( 'scroll' );
            window.scrollTo( 0, 1 );

           

        }, 1000 );

        setTimeout( () => {
            this.firstStepInit = false;
            this.currentSymbolList();
        }, 5000 );
        
       
       

    }

    ngOnInit () {
        this.symbolTypeService.subscriber.subscribe( t => {
            //  console.log(this.workspaceService.data.activeBasket);
            if ( this.workspace.activeBasket != -1 ) {
                this.filterBasketItemsByActiveBasket();
                this.currentSymbolList();
                // this.refreshSymbolAfterChanges();
            } else {
                this.symbols = this.workspace.getSymbolsTypeSlit( t );
                this.currentSymbolList();
                this.setChangeView( true );
            }
            // this.refreshSymbolAfterChanges();
        } );

        this.globaGridMode.changeActiveBasket.subscribe( x => {
            if ( x != -1 ) {
                this.filterBasketItemsByActiveBasket();
                this.currentSymbolList();
                this.setChangeView( true );
            } else {
                this.symbols = this.workspace.getSymbolsTypeSlit( this.workspace.activeSymbolType );
                this.currentSymbolList();
                this.setChangeView( true );
            }

            
    
            // if(this.currentSymbol!="AUD/CAD" )
            // {
            //     console.log("this.currentSymbol");
            //     console.log(this.currentSymbol);
            //      this.setActiveSymbol (this.currentSymbol);
            // }

            //  this.refreshSymbolAfterChanges();
        } );

        this.globaGridMode.symbolChangedSubscriber.subscribe( x => {
            this.setChangeView( true );
        } );

        this.globaGridMode.mobileViewUpdate.subscribe( x => {
            if ( x == "fromwiz" ) {
                this.workspace.chartDisplayMode = this.workspace.lastChartViewNoEntry;
            }

            this.setChangeView( true );
        } );

        this.quoteDisplayMode = 2;

        // if(this.workspace.charts["ach1"].instance)
        // {
        //   this.period = this.workspace.charts["ach1"].instance.period;
        // }

        // this.changeModeTracker()
    }

    public get initialLeaderBoardPanel () {
        return this.workspace.challengeActiveTab;
    }

    private _prevHorizontalMode: boolean | null = null;
    public get prevHorizontalMode (): boolean | null {
        return this._prevHorizontalMode;
    }
    public set prevHorizontalMode ( value: boolean | null ) {
        this._prevHorizontalMode = value;
    }

    public changeModeTracker () {
        setTimeout( () => {
            //    this.initScroll();

            if ( this.horizontalMode != this.prevHorizontalMode ) {
                //   this.entryHeights = this.chartColumnHeight;
                if ( !this.entrySignalsMultipleCharts ) {
                  //  debugger;
                    this.setActiveEntrySignal( this.selectedEntryPeriod );
                } else {
                    this.setChartSelected( true );
                }
                this.prevHorizontalMode = this.horizontalMode;
            }

            this.changeModeTracker();
        }, 100 );
    }

    private _entryHeights: string = "";
    public get entryHeights (): string {
        return this._entryHeights;
    }
    public set entryHeights ( value: string ) {
        this._entryHeights = value;
    }

    get entrySignalsMultipleCharts () {
        if ( this.horizontalMode && this.workspace.chartDisplayMode == "signals" ) {
            this.workspace.entrySignalsMultipleCharts = true;
            return true;
        } else {
            this.workspace.entrySignalsMultipleCharts = false;
            return false;
        }
    }

    get homeComponent () {
        return this;
    }

    private _currentView: MobileMainView = MobileMainView.PANEL;
    public get currentView (): MobileMainView {
        return this.workspace.mobileView;
    }
    public updateView ( value: MobileMainView ) {
      //  debugger;
        this.workspace.mobileView = value;
        //this.mainFooterHeight="60px";

        if ( this.currentView != MobileMainView.PANEL ) {
            this.showPanel = false;
            //  this.mainFooterHeight="85px";
        }

        if ( this.currentView != MobileMainView.TRADEDESK ) {
            this.showTradeDesk = false;
        }

        switch ( value ) {
            case MobileMainView.PANEL:
                this.showPanel = true;
                break;

            case MobileMainView.TRADEDESK:
                this.showTradeDesk = true;
                break;
        }
    }

    private _showPanel: boolean = true;
    public get showPanel (): boolean {
        return this._showPanel;
    }

    public mobileMainViewENUM = MobileMainView;

    public set showPanel ( value: boolean ) {
        this._showPanel = value;

        if ( value == true ) {
            setTimeout( () => {
                //    this.initScroll();
                this.showBoxes = true;
            }, 100 );
        } else {
            this.showBoxes = false;
        }
    }

    private _showBoxes: boolean = true;
    public get showBoxes (): boolean {
        return this._showBoxes;
    }
    public set showBoxes ( value: boolean ) {
        this._showBoxes = value;
    }

    private _devShow: boolean = false;
    public get devShow (): boolean {
        return this._devShow;
    }
    public set devShow ( value: boolean ) {
        this._devShow = value;
    }

    public tabsList: object = quotePanelsTabsParams();

    private _quoteFilterList: object = quoteFilterTabsParamsMobile();
    public get quoteFilterList(): object {
        return this._quoteFilterList;
    }
    public set quoteFilterList(value: object) {
        this._quoteFilterList = value;
    }



    public afterInit:boolean = false;

    public get filteredSymbolTypes () {
        // if(this.hideNonTournamentsTabs)
        // {
        //   let l = this.quoteFilterList as Array<{ id: string, label: string }>
        //   return l.filter((v:any)=>{
        //     if(v.id==quoteFilterTabsList.FOREX)
        //     {
        //        return v
        //     }

        //   });
        // }
        if((this.workspaceService.data.currentProvider==Providers.OANDA || this.workspaceService.data.currentProvider==Providers.GAIN) && !this.afterInit)
        {
            this.quoteFilterList = quoteFilterTabsParamsOanda();
            this.afterInit = true;
            this.setActiveQuoteFilter(SymbolTypeEnum.Forex);
            
        }

        if(this.workspaceService.data.currentProvider=="DEMO" && this.afterInit)
        {
            this.quoteFilterList = quoteFilterTabsParamsMobile();
            this.afterInit = false;
        }

        return this.quoteFilterList;
    }

    get basketList () {
        //  let basketsList: { id: string, label: string }[] = this.workspace.Baskets.map((v,index)=>{

        //     let l:{ id: string, label: string } = {id:String(index), label: "Basket " + String(1+index)}
        //     return l;

        //  });

        //   let first: { id: string, label: string }[] = [{id:"-1", label: "Default"}];
        return this.workspace.mobileBasketList;
    }

    public get showSupportButtons (): boolean {
        return false;
    }

    public showChartMenu () {
        const chart = this.workspace.charts[ "ach1" ].instance;
        if ( chart ) chart.showContextmenu( null as any, true );
    }

    public get initialTab (): any {
        return this.workspace.activeTab;
    }

    public get initialQuoteFilter (): any {
        return this.workspace.activeSymbolType;
    }

    public get initialBasket () {
        return this.workspace.activeBasket;
    }

    set activeTab ( v: any ) {
        if ( v != QuotePanelsTabsList.SYMBOL ) {
            this.showPanel = false;
        } else {
            this.showPanel = true;
        }
        this.workspace.activeTab = v;
    }

    get activeTab () {
        return this.workspace.activeTab;
    }

    public setActivePanel ( e: any ) {
        this.activeTab = e;
    }

    set activeQuoteFilter ( v: any ) {
        this.workspace.activeSymbolType = v;
    }

    get activeQuoteFilter () {
        return this.workspace.activeSymbolType;
    }

    public setActiveQuoteFilter ( e: any ) {
        this.activeQuoteFilter = e;
    }

    public setActiveMainView ( e: any ) {
        this.updateView( e );
    }

    public setActiveBasket ( e: any ) {
        this.activeBasket = Number( e );
    }

    calculatePanelContainerHeight () {
        let topBarHeight = this.mobileFooter!.nativeElement.offsetHeight;
        return {
            height: `calc(100% - ${ topBarHeight }px)`
        };
    }

    public backAction ( e: any ) {
        this.showPanel = true;
    }

    get hideNonTournamentsTabs () {
        if (
            this.workspaceService.data.competitionAccountList.indexOf( this.workspaceService.data.activeAccountIdBySet ) >
            -1
        ) {
            return true;
        } else {
            return false;
        }
    }

    public get showMobileLandingPage (): boolean {
        return this.workspace.showMobileLandingPage;
    }

    public set showMobileLandingPage ( v: boolean ) {
        this.workspace.showMobileLandingPage = v;
    }

    private _showFilterSymbol: boolean = false;
    public get showFilterSymbol (): boolean {
        return this._showFilterSymbol;
    }
    public set showFilterSymbol ( value: boolean ) {
        this._showFilterSymbol = value;
    }

    private _showBaskets: boolean = false;
    public get showBaskets (): boolean {
        return this._showBaskets;
    }
    public set showBaskets ( value: boolean ) {
        this._showBaskets = value;
    }

    private _showSymbols: boolean = false;
    public get showSymbols (): boolean {
        return this._showSymbols;
    }
    public set showSymbols ( value: boolean ) {
        this._showSymbols = value;
    }

    private _showTradeDeskMobile: boolean = false;
    public get showTradeDeskMobile (): boolean {
        return this._showTradeDeskMobile;
    }
    public set showTradeDeskMobile ( value: boolean ) {
        this._showTradeDeskMobile = value;
    }

    private _showChartBtns: boolean = false;
    public get showChartBtns (): boolean {
        return this._showChartBtns;
    }
    public set showChartBtns ( value: boolean ) {
        this._showChartBtns = value;
    }

    public showLeaderBoard: boolean = false;

    public setChangeView ( e: any ) {
        this.showFilterSymbol = false;
        this.showBaskets = false;
        this.showSymbols = false;
        this.showTradeDeskMobile = false;
        this.showChartBtns = false;
        this.showLeaderBoard = false;
        //this.workspace.alertsAccess = false;

        if ( this.currentView == MobileMainView.PANEL ) {
            if ( this.workspaceService.data.activeTab == QuotePanelsTabsList.SYMBOL ) {
                this.showFilterSymbol = true;
                this.showBaskets = true;
            }

            if ( this.workspaceService.data.activeTab == QuotePanelsTabsList.MONITOR ) {
                this.showFilterSymbol = true;
                this.showBaskets = true;
            }

            if ( this.workspaceService.data.activeTab == QuotePanelsTabsList.WIZARD ) {
                this.showFilterSymbol = true;
                this.showSymbols = true;
            }

            if ( this.workspaceService.data.activeTab == QuotePanelsTabsList.LEADERBOARD ) {
                this.showLeaderBoard = true;
            }

            if ( this.workspaceService.data.activeTab == QuotePanelsTabsList.ALERTS ) {
                //   this.workspace.alertsAccess = true;
            }
        }

        if ( this.currentView == MobileMainView.TRADEDESK ) {
            this.showTradeDeskMobile = true;
        }

        if ( this.currentView == MobileMainView.CHARTING ) {
            this.showFilterSymbol = true;
            this.showSymbols = true;
            this.showChartBtns = true;
            this.workspace.charts[ "ach1" ].instance!.refreshPeriod( undefined, true );
        }

        if ( e == "basket" ) {
            //this.showAddToBasketMenu = true;
            this.showBaskets = true;
            this.showAddSymbolsToBasketModal();
        }
    }

    public viewUpdate () {
        // alert("123");
        this.setChangeView( true );
    }

    public timeo: any;

    public symbols: string[] = [];
    public symbolItems: { id: string; label: string }[] = [];
    public currentSymbolList () {
        //this.workspace.activeSymbolType
        // this.boxes = this.workspace.getSymbolsTypeSlit(this.workspace.activeSymbolType);

        this.symbolItems = this.symbols
            .map( v => {
                let l: { id: string; label: string } = { id: String( v ), label: String( v ) };
                return l;
            } )
            .filter( l => {
                if ( this.workspace.competitionAccountList.indexOf( this.workspace.activeAccountIdBySet ) > -1 || this.workspace.currentProvider!=Providers.DEMO ) {
                    // console.log(this.workspace.currentTournaments[0].tournamentAssets);
                    if ( this.workspace.allowedForexSymbols.indexOf( l.label ) > -1 ) {
                        //&& this.workspace.currentTournaments[0].tournamentAssets.Assets.indexOf(0))
                        return true;
                    } else {
                        return false;
                    }
                } else {
                    return true;
                }
            } );

        if ( this.symbolItems.length == 0 ) {
            clearTimeout( this.timeo );
            this.timeo = setTimeout( () => {
                //     console.log("this.symbolItems")
                //      console.log(this.symbolItems)
                let l = this.activeBasket;

          //      this.activeBasket = -1;
        //        this.activeBasket = l;

                //  if(this.workspace.getActiveBasketItems().length!=0)
                //   {
                this.currentSymbolList();
                //    }
            }, 500 );
        }

        return this.symbolItems;
    }

    private filterBasketItemsByActiveBasket () {
        if ( this.workspace.getActiveBasketItems() !== undefined ) {
            let selected = this.workspace.getActiveBasketItems().filter( v => {
                let element = this.workspace.SymbolInfoes.filter( t => {
                    if ( t.Symbol === v ) {
                        return t.Type;
                    }
                } );
                if ( element[ 0 ].Type === this.workspace.activeSymbolType ) {
                    return element[ 0 ].Symbol;
                }
            } );

            this.symbols = selected;
            // this.workspace.AppTick();
        }
    }

    public get item (): BoxQuotaData | null {
        let res = this.workspace.boxes.filter( x => x.Symbol == this.currentSymbol );
        return res.length > 0 ? res[ 0 ] : null;
    }

    public get currentSymbol () {
        return this.workspace.charts[ "ach1" ].Symbol;
    }

    public setActiveSymbol ( e: any ) {
        this.workspace.charts[ "ach1" ].Symbol = e;
        this.workspace.charts[ "ach1" ].instance!.onSelectNewSymbol( e );

        this.workspace.charts[ "ach2" ].Symbol = e;
        this.workspace.charts[ "ach2" ].instance!.onSelectNewSymbol( e );

        this.workspace.charts[ "ach3" ].Symbol = e;
        this.workspace.charts[ "ach3" ].instance!.onSelectNewSymbol( e );

        this.workspace.charts[ "ach4" ].Symbol = e;
        this.workspace.charts[ "ach4" ].instance!.onSelectNewSymbol( e );
    }

    public lostSymbolAction ( e: any ) {
        if ( this.workspace.competitionAccountList.indexOf( this.workspace.activeAccountIdBySet ) > -1 ) {
            console.log( "TOURNAMENTS" );

            if ( this.symbolItems[ 0 ] == undefined ) {
                this.setActiveQuoteFilter( "forex" );
            } else {
                this.setActiveSymbol( this.symbolItems[ 0 ].label );
            }
        } else {
            if ( this.symbolItems.length > 0 ) {
                console.log( "ASSETS" );
                console.log( this.symbolItems );
                this.setActiveSymbol( this.symbolItems[ 0 ].label );
            }
        }
    }

    public setActiveTradeDeskTab ( tabId: any ) {
        this.activeTradeDeskTab = tabId;
        this.mainUIService.TabsActive.next( tabId );
        this.workspace.activeOrderTab = tabId;
    }

    tradeDesktabs: object = tradeDeskTabsParams();

    /**CHARTING */

    public get seriesTypes () {
        if ( this.workspace.charts[ "ach1" ].instance != undefined ) {
            return this.workspace.charts[ "ach1" ].instance.seriesTypes;
        }
    }

    public get currentSerieType () {
        //this.workspace.se
        if ( this.workspace.charts[ "ach1" ].instance != undefined ) {
            return this.workspace.charts[ "ach1" ].instance.chartSerieType;
        }
    }

    public setActiveSeriesType ( v: any ) {
        this.workspace.charts[ "ach1" ].instance!.chartSerieType = v;
    }

    public get periods () {
        if ( this.workspace.charts[ "ach1" ].instance != undefined ) {
            return this.workspace.charts[ "ach1" ].instance.periods;
        }
    }

    private _period: any;
    public get period () {
        if ( this.workspace.chartDisplayMode == ChartDisplayMode.ENTSIGNALS ) {
            return this._period != undefined ? this._period : this.workspace.charts[ "ach1" ].instance!.period;
        } else {
            if ( this.workspace.charts[ "ach1" ].instance != undefined ) {
                this.selectedEntryPeriod = "Long";
                return this.workspace.charts[ "ach1" ].instance.period;
            }
        }
    }

    public set period ( v: any ) {
        if ( this.workspace.chartDisplayMode == ChartDisplayMode.ENTSIGNALS ) {
            this._period = v;
        }
    }

    private _mainFooterHeight: string = "85px";
    public get mainFooterHeight (): string {
        if ( this.currentView == MobileMainView.TRADEDESK ) {
            return "35px";
        }

        if ( this.currentView == MobileMainView.CHARTING ) {
            return "30px";
        }

        if(this.currentProvider==Providers.OANDA)
        {
            return "100px";
        }

        return this._mainFooterHeight;
    }
    public set mainFooterHeight ( value: string ) {
        this._mainFooterHeight = value;
    }

    public setChartSelected ( e: any ) {
        // console.log(this.selectedChart.itemID);
        this.period = this.workspace.charts[ this.selectedChart.itemID ].instance!.period;

        switch ( this.selectedChart.itemID ) {
            case "ach1":
                this.selectedEntryPeriod = "Long";
                break;

            case "ach2":
                this.selectedEntryPeriod = "Short";
                break;

            case "ach3":
                this.selectedEntryPeriod = "Mid";
                break;

            case "ach4":
                this.selectedEntryPeriod = "Entry";
                break;
        }
    }

    private _firstStepInit: boolean = true;
    public get firstStepInit (): boolean {
        return this._firstStepInit;
    }
    public set firstStepInit ( value: boolean ) {
        this._firstStepInit = value;
    }

    public setActivePeriod ( e: any ) {
        if ( this.entrySignalsMultipleCharts ) {
            this.workspace.charts[ this.selectedChart.itemID ].instance!.period = e;
        } else {
            switch ( this.selectedEntryPeriod ) {
                case "Long":
                    this.workspace.charts[ "ach1" ].instance!.period = e;
                    break;

                case "Mid":
                    this.workspace.charts[ "ach2" ].instance!.period = e;
                    break;

                case "Short":
                    this.workspace.charts[ "ach3" ].instance!.period = e;
                    break;

                case "Entry":
                    this.workspace.charts[ "ach4" ].instance!.period = e;
                    break;
            }
        }
    }

    get chartButtonsPx () {
        return this.buttonPans!.nativeElement.offsetHeight + this.headerHeightPx - 5 || 0;
    }

    public get chartColumnHeight () {
        return "calc(100% - " + this.chartButtonsPx + "px)";
    }

    private _selectedEntryPeriod: string = "Long";
    public get selectedEntryPeriod (): string {
        return this._selectedEntryPeriod;
    }
    public set selectedEntryPeriod ( value: string ) {
        this._selectedEntryPeriod = value;
    }

    public setActiveEntrySignal ( v: any ) {
        this.selectedEntryPeriod = v;
        switch ( v ) {
            case "Long":
                this.period = this.workspace.charts[ "ach1" ].instance!.period;
                this.workspace.charts[ "ach1" ].instance!.isSelected = true;
                break;

            case "Mid":
                this.period = this.workspace.charts[ "ach2" ].instance!.period;
                this.workspace.charts[ "ach2" ].instance!.isSelected = true;
                break;

            case "Short":
                this.period = this.workspace.charts[ "ach3" ].instance!.period;
                this.workspace.charts[ "ach3" ].instance!.isSelected = true;
                break;

            case "Entry":
                this.period = this.workspace.charts[ "ach4" ].instance!.period;
                this.workspace.charts[ "ach4" ].instance!.isSelected = true;
                break;
        }

        // }
    }

    public setActiveLeaderBoardPanel ( e: any ) {
        this.workspace.challengeActiveTab = e;
    }
}
